import { Time } from '@angular/common';
import { BaseDto } from './base.dto';
import { MenuDto } from './menu.dto';
import { OrderTypeDto } from './orderType.dto';

export class MenuHoursDto extends BaseDto {
  isAvailable: boolean;
  isOverNight?: boolean;
  isEnabled?: boolean;
  menuId: number;
  weekday: number;
  startTime: Time;
  endTime: Time;
  orderTypeId?: number;
  menu?: MenuDto;
  orderType?: OrderTypeDto;
}
